import React, { createContext, useContext, useEffect, useState } from "react";
import { UiComponents } from "@simulanisindia/ui";
import GroupAddData from "../GroupAddData";
import UserAddData from "../UserAddData";
import { GroupCSVUploadModal, UserCSVUploadModal } from "../UploadCSVModal";
import CSVModalTable from "../CSVModalTable";
import { modalName } from "../../utils/general";
import Move from "../Move";
import VerifyAnimationModal from "../VerifyAnimationModal";
import DataTransferAnimatedModal from "../DataTransferAnimatedModal";
import ShareModal from "../ShareModal";
import PasswordChangeModal from "../PasswordChangeModal";
import useWindowDimensions from "../../utils/useWindowDimension.js";
import { isMobile } from "../../utils/common.js";
import { saveMobileView } from "../../store/slice/configSlice.js";
import AssignRoleUserModal from "../AssignRoleUserModal";
import { useDispatch, useSelector } from "react-redux";

const { SimModal, ConfirmBox } = UiComponents;

const ModalContext = createContext();

let initialStage = {
  modalName: "",
  status: false,
  type: null,
  id: null,
  data: null,
  csvList: [],
  loading: false,
  transferring: false,
  modalSize: "md",
  message: "",
  title: "",
  confirmBtnName: "",
};

export const ModalProvider = ({ children }) => {
  const [modalState, setModalState] = useState(initialStage);
  const windowDimensions = useWindowDimensions();
const dispatch = useDispatch();
  const openModal = (data = {}) => {
    setModalState({ ...data, status: true });
  };
  const handleLoading = (value) => {
    setModalState((pre) => ({ ...pre, loading: value }));
  };
  const closeModal = () => {
    setTimeout(() => {
      setModalState(initialStage);
    }, 500);
  };

  const { isMobile: isMobileView } = useSelector((state) => state.configSlice);

  useEffect(() => {
    const isMobileView = isMobile(windowDimensions.width, windowDimensions.height);
    dispatch(saveMobileView(isMobileView));
  }, [windowDimensions.height, windowDimensions.width]);

  useEffect(() => {
    if (isMobileView) {
      document.body.classList.add("mobile-view");
    } else {
      document.body.classList.remove("mobile-view");
    }
  }, [isMobileView]);

  return (
    <ModalContext.Provider value={{ modalState, openModal, closeModal, handleLoading }}>
      {children}

      <SimModal showModal={modalState.status} onHide={closeModal} centered={true} size={modalState.modalSize}>
        {modalState.modalName === modalName.GROUP_ADD && <GroupAddData isMobileView={isMobileView} />}

        {modalState.modalName === modalName.USER_ADD && <UserAddData isMobileView={isMobileView} />}

        {modalState.modalName === modalName.GROUP_USER_MOVE && <Move />}

        {modalState.modalName === modalName.GROUP_CSV && <GroupCSVUploadModal />}

        {modalState.modalName === modalName.USER_CSV && <UserCSVUploadModal />}

        {modalState.modalName === modalName.TABLE_CSV && <CSVModalTable />}

        {modalState.modalName === modalName.SUCCESSFULLY_POPUP && (
          <DataTransferAnimatedModal
            showModal={modalState.status}
            onHide={closeModal}
            message={modalState.message}
            transferring={modalState.transferring}
            movingData={modalState?.movingData || null}
            modalSize="lg"
          />
        )}

        {modalState.modalName === modalName.SHARE_RESOURCE && <ShareModal />}

        {modalState.modalName === modalName.PASSWORD_CHANGE && <PasswordChangeModal />}

        {modalState.modalName === modalName.ASSIGN_ROLE && <AssignRoleUserModal />}
      </SimModal>

      {modalState.modalName === modalName.CONFIRM_BOX && (
        <ConfirmBox
          onHide={closeModal}
          showModal={modalState.status}
          alertTitle={modalState.title}
          alertMessage={modalState.message}
          actionButtonItem={modalState.confirmBtnName}
          onActionClick={() => {
            handleLoading(true);
            modalState.handleConfirmClick();
          }}
          clickLoading={modalState.loading}
        />
      )}
    </ModalContext.Provider>
  );
};

export const useModalContext = () => {
  return useContext(ModalContext);
};
